import { WrenchScrewdriverIcon } from "@heroicons/react/24/outline";

/**
 * Shared "not built yet" surface for console sections whose backend does not exist.
 *
 * The point of naming `missingApi` is that these screens stay honest: the console shows its intended
 * shape without any of them implying data is being withheld, and whoever picks the section up next
 * can see exactly what has to be built first.
 */
interface PlatformPlaceholderPageProps {
  title: string;
  description: string;
  missingApi: string;
}

export function PlatformPlaceholderPage({
  title,
  description,
  missingApi,
}: PlatformPlaceholderPageProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="page-title">{title}</h1>
        <p className="subtitle">{description}</p>
      </div>

      <div className="rounded-md border border-dashed border-slate-300 bg-white p-10 text-center dark:border-slate-700 dark:bg-slate-900">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 dark:bg-slate-800">
          <WrenchScrewdriverIcon
            className="h-6 w-6 text-slate-400 dark:text-slate-500"
            aria-hidden="true"
          />
        </div>
        <p className="card-title mt-4">Not yet available</p>
        <p className="subtitle mx-auto mt-1 max-w-md">
          This section has no backing API yet, so there is nothing real to show. The
          navigation entry is here so the console&rsquo;s intended shape stays visible.
        </p>
        <p className="caption mx-auto mt-4 max-w-md">
          Needs:{" "}
          <span className="font-medium text-slate-600 dark:text-slate-300">
            {missingApi}
          </span>
        </p>
      </div>
    </div>
  );
}
